exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".body {\n\theight: '100%';\n\tmargin: 12px 12px 0;\n}\n\n.body > div {\n\tbackground: #fff;\n\tborder-radius: 0.25rem;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n    bottom: 0;\n    left: calc(20% + 12px);\n    position: fixed;\n    right: 12px;\n    top: 161px;\n}\n\n.body.no-guide > div {\n\ttop: 64px !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Body/body.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/Body/body.css
// module chunks = 0